"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
exports.default = new Network_1.default('bifrost', [
    new Token_1.default('bfc', 'BFC', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} BFC', 'icon/bfc.svg'),
    new Token_1.default('eth', 'ETH', 'bifi', 1, '0x6c9944674C1D2cF6c4c4999FC7290Ba105dcd70e', '', false, true, false, [], '{} biETH', 'icon/eth.svg'),
    new Token_1.default('bnb', 'BNB', 'bifi', 2, '0xB800EaF843F962DFe5e145A8c9D07A3e70b11d7F', '', false, true, false, [], '{} biBNB', 'icon/bnb.svg'),
    new Token_1.default('matic', 'MATIC', 'bifi', 3, '0x21ad243b81eff53482F6F6E7C76539f2CfC0B734', '', false, true, false, [], '{} MATIC', 'icon/matic.svg'),
    new Token_1.default('usdc', 'USDC', 'bifi', 4, '0x640952E7984f2ECedeAd8Fd97aA618Ab1210A21C', '', false, true, false, [], '{} biUSDC', 'icon/usdc.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0x047938C3aD13c1eB821C8e310B2B6F889b6d0003', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'bfc'),
    new Handler_1.default(1, 'eth'),
    new Handler_1.default(2, 'bnb'),
    new Handler_1.default(3, 'matic'),
    new Handler_1.default(4, 'usdc')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('bifi.getOraclePeriodDelta', 'callProxyOracle_getPeriodDelta()', [], [
        '(uint256,uint256,uint256,int256,bool)[]',
        'bool'
    ]),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionNFT(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0x24Eb3E8Ee3504578D180FE386A4aD21EBfaB40b4'),
    new EntryPoint_1.default('xBifi', '0x8BD0374CD8790BC0DB2096f361d5b915C5b7A02B'),
    new EntryPoint_1.default('xBifi.factory', '0x82A83Ba7c413353CF95465CbE6B4bC139f902c04')
], 3000);
//# sourceMappingURL=bifrost.js.map